<template>
  <div class="results">
    <div v-if="contentType === contentTypes.course" class="results__grid">
      <CourseTile
        v-for="item in items"
        :key="item.objectID"
        :course="item"
        :isFreeTrialUser="isFreeTrialUser"
        :progress="getCourseProgress(item)"
        :showAddedDate="true"
        :height="isMobile ? 171 : 245"
        @element-render="handleRememberPosition"
      />
    </div>
    <div
      v-if="contentType === contentTypes.learning_path"
      class="results__grid"
    >
      <LearningPathTile
        v-for="item in items"
        :key="item.objectID"
        :path="item"
        @element-render="handleRememberPosition"
      />
    </div>
    <div v-if="contentType === contentTypes.videos" class="results__flex-grid">
      <VideoTileResults
        :items="items"
        :parentsSearchResults="parentsSearchResults"
        @open-video="$emit('open-video', $event)"
      />
    </div>
    <div
      v-if="contentType === contentTypes.bootcamp"
      class=" results__flex-grid"
    >
      <BootcampTileResults
        :items="items"
        :isFreeTrialUser="isFreeTrialUser"
        @element-render="handleRememberPosition"
      />
    </div>
    <template v-if="contentType === contentTypes.lab">
      <LabsTileResults
        :items="items"
        :parentsSearchResults="parentsSearchResults"
        @element-render="handleRememberPosition"
      />
    </template>
  </div>
</template>

<script>
import CONSTANTS from '@/constants'
import CourseTile from '@/components/layout/CourseTile.vue'
import LearningPathTile from '@/components/layout/LearningPathTile.vue'
import BootcampTileResults from '@/components/search/BootcampTileResults.vue'
import VideoTileResults from '@/components/search/VideoTileResults.vue'
import LabsTileResults from '@/components/search/LabsTileResults.vue'

export default {
  name: 'TileResults',
  components: {
    CourseTile,
    LearningPathTile,
    BootcampTileResults,
    VideoTileResults,
    LabsTileResults,
  },
  data: () => {
    return {
      parents: CONSTANTS.SEARCH.PARENTS,
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    contentType: {
      type: String,
      required: true,
    },
    isFreeTrialUser: {
      type: Boolean,
      required: false,
      default: () => {
        return false
      },
    },
    parentsSearchResults: {
      type: Object,
      required: false,
    },
    activeCourses: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
  },
  inject: ['getBreakpoint'],
  computed: {
    isMobile() {
      return this.getBreakpoint() === 'mobile'
    },
    contentTypes() {
      return CONSTANTS.SEARCH.PARENTS
    },
  },
  methods: {
    openVideo(video) {
      this.$emit('open-video', video)
    },
    getCourseProgress(course) {
      let progress
      progress = course?.user_status?.progress ?? course?.progress ?? 0
      if (progress) {
        return progress
      }
      const findFunc = activeCourse => {
        return activeCourse.id === course.objectID
      }
      if (this.activeCourses.length) {
        const ac = this.activeCourses.find(findFunc)
        if (ac) {
          progress = Math.floor(ac.user_status.progress * 100)
        }
      }
      return progress > 0 ? progress : 0
    },
    handleRememberPosition(elId) {
      this.$emit('element-rendered', elId)
    },
    getParent(item, key) {
      return this.parentsSearchResults[this.parents[item.parent_type]][key]
    },
    getParentBackground(item, key) {
      const parent = this.getParent(item, key)
      let background = ''
      if (!parent) return ''

      // we get directly from parent because it may have another background field
      if (item.parent_type === 'bootcamp') {
        background = parent.background_image_url || ''
      } else {
        background = parent.images ? parent.images.small_image_url : ''
      }

      return background
    },
  },
}
</script>

<style lang="scss" scoped>
.results {
  &__grid {
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 1fr;
    grid-gap: 10px;
    @include tablet {
      grid-template-columns: 1fr 1fr;
    }
    @include desktop {
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 8px;
    }
    @include lg-desktop {
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 10px;
    }
  }
  &__flex-grid {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
